import React from "react"
import "./Layout.scss"

export const Row: React.FC = ({children}) => <div className="neo__layout__row">{children}</div>
